<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h2 id="header-text">Select Propulsion Scenario(s) to update with Propulsion Portfolio:</h2>
  <div id="actions-container">
    <button mat-flat-button id="select-all-button" class="action-button default-margin"
            (click)="onSelectAll()">
      Select All
    </button>
    <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" id="add-button" class="action-button"
            (click)="onConfirm()"
            [disabled]="selectedOptions.length === 0">
      Confirm
    </button>
  </div>
</div>
<div mat-dialog-content>
  <div class="checkbox-float">
    <mat-checkbox [(ngModel)]="isRemoveUnmatched"
                  (change)="onCheckboxChange()">
      Remove Unmatched Records with Penetrations within CY START YYYY and CY END YYYY
    </mat-checkbox>
    <ng-container *ngIf="isRemoveUnmatched">
      <p>To update the Propulsion portfolio and preserve historical and short term data in a Propulsion scenario,
        please specify a range of dates where unmatched records can be deleted.
      </p>
      <br/>
      <h4>
        <b>Full Description:</b>
      </h4>
      <p>
        For records in PROP scenario with penetrations solely within the CY Start and CY End range but unmatched to PROP
        portfolio, remove from PROP scenario. Unmatched records with penetrations outside of CY Start and CY End range
        remain in scenario.
      </p>
    </ng-container>
    <ng-container *ngIf="isRemoveUnmatched">
      <mat-form-field class="filter-options">
        <mat-label class="asterisk--before">Start Year</mat-label>
        <mat-select [(ngModel)]="selectedStartYear" id="startYear">
          <mat-option *ngFor="let year of scenarioYearRange" [value]="year">{{year}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="filter-options">
        <mat-label class="asterisk--before">End Year</mat-label>
        <mat-select [(ngModel)]="selectedEndYear" id="endYear">
          <mat-option *ngFor="let year of scenarioYearRange" [value]="year">{{year}}</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </div>
  <div>
    <mat-selection-list [multiple]="true" [(ngModel)]="selectedOptions">
      <mat-list-option *ngFor="let scenario of scenarios"
                       [value]="scenario"
                       matTooltip="{{scenario.propulsionScenario.id + ' ' + scenario.propulsionScenario.propulsionScenarioName}}"
                       matTooltipPosition="before">
        {{scenario.propulsionScenario.id + ' ' + scenario.propulsionScenario.propulsionScenarioName}}
      </mat-list-option>
    </mat-selection-list>
  </div>
</div>
